import { X } from 'lucide-react';
import ComingSoonImage from '../../assets/images/common/coming-soon.png';

const ComingSoonModal = ({ isOpen, onClose }) => {
    if (!isOpen) return null;
    return (
        <div className="fixed inset-0 bg-black/60 z-[2000] flex items-center justify-center p-4" onClick={onClose}>
            <div className="relative bg-white rounded-2xl p-8 max-w-sm w-full text-center shadow-2xl" onClick={e => e.stopPropagation()}>
                <button onClick={onClose} className="absolute top-3 right-3 text-gray-400 hover:text-gray-600">
                    <X size={24} />
                </button>
                <img src={ComingSoonImage} alt="Coming Soon" className="w-60 mx-auto mb-4" />
                <h2 className="text-2xl font-bold text-gray-800 mb-2">Coming Soon!</h2>
                <p className="text-gray-500 mb-6">We're working hard to bring this feature to you. Stay tuned!</p>
                <button onClick={onClose} className="bg-primary text-white px-6 py-2 rounded-lg font-semibold hover:opacity-90 transition-opacity">
                    Got it
                </button>
            </div>
        </div>
    );
};

export default ComingSoonModal;
